import {logger, LongId, Util} from 'yougile-util'
import {DataObjectId} from 'yougile-model'
import {Backend} from './backend'
import {AmplitudeUserProps} from './tracking-events'

let sessionId: LongId | undefined = undefined
const platform = Util.isDesktop() ? 'desktop' : 'web'

const headers = (): {[header: string]: string} => ({
  'x-analytics-token': Backend.analyticPlatformToken ?? '',
  'content-type': 'application/json'
})

const isAnalyticsDisabled = () =>
  !Backend.analyticPlatformToken || !Backend.analyticPlatformUrl || !sessionId

export const init = () => {
  sessionId =
    (sessionStorage.getItem('ya-session-id') as LongId) ?? Util.longId()
  sessionStorage.setItem('ya-session-id', sessionId as string)
}

export const capture = async (
  eventId: string,
  props?: {[key: string]: unknown}
) => {
  if (isAnalyticsDisabled()) {
    return
  }
  try {
    await fetch(
      new URL(
        `/analytics/session/${sessionId}/event/${eventId}`,
        Backend.analyticPlatformUrl
      ),
      {
        headers: new Headers(headers()),
        method: 'POST',
        body: JSON.stringify({data: props})
      }
    )
  } catch (error) {
    logger.warn('Error sending analytics', error)
  }
}

export const setPersonProperties = async (
  userId?: DataObjectId,
  props?: AmplitudeUserProps
) => {
  if (isAnalyticsDisabled()) {
    return
  }
  try {
    const payload: AmplitudeUserProps & {user_id?: string} = props ?? {}
    payload.platform = platform
    payload.hostname = Backend.dataHost()
    if (userId) {
      payload.user_id = userId
    }
    await fetch(
      new URL(`/analytics/session/${sessionId}`, Backend.analyticPlatformUrl),
      {
        headers: new Headers(headers()),
        method: 'POST',
        body: JSON.stringify(payload)
      }
    )
  } catch (error) {
    logger.warn('Error sending analytics', error)
  }
}

export const finishSession = async () => {
  if (isAnalyticsDisabled()) {
    return
  }
  try {
    await fetch(
      new URL(
        `/analytics/session/${sessionId}/finish`,
        Backend.analyticPlatformUrl
      ),
      {
        headers: new Headers(headers()),
        method: 'POST',
        body: JSON.stringify({})
      }
    )
  } catch (error) {
    logger.warn('Error sending analytics', error)
  }
}
